import React, { Component } from 'react'

import Img from 'gatsby-image'

import './style.scss'

export default class ArticleMiniTeaser extends Component {
  render() {
    const {
      fields: { slug },
      frontmatter: { title, cover_image: cover, category },
      excerpt,
    } = this.props.data
    return (
      <article className="c-mini-article-teaser border-bottom py-2">
        <a href={slug}>
          <h6 className="c-mini-title--no-dash c-mini-article-teaser__category">
            {category}
          </h6>
          <h3 className="my-1 c-mini-article-teaser__title">{title}</h3>
          <div className="c-mini-article-teaser__cover">
            <Img
              style={{ width: '100%', height: '100%' }}
              fluid={cover.childImageSharp.fluid}
            />
          </div>
        </a>
      </article>
    )
  }
}
